import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import globalStyles from './pc-icon-link.lightDom.css.lit';
import '../pc-icon/pc-icon';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

/**
 * Icon Link component
 * @element pc-icon-link
 * @slot - This element has a default slot
 */
@customElement('pc-icon-link')
export class PCIconLink extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: Boolean, attribute: 'show-label' })
  showLabel = false;

  connectedCallback() {
    super.connectedCallback();

    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-icon-link': PCIconLink;
  }
}
